import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: 'Marco R.',
    location: 'Milano, Italia',
    text: 'Itaobuy Spreadsheet ha completamente cambiato il mio modo di cercare prodotti. Le tabelle sono organizzate benissimo e risparmio tantissimo tempo nel confrontare le diverse opzioni disponibili.',
    rating: 5,
  },
  {
    name: 'Giulia B.',
    location: 'Roma, Italia',
    text: 'Utilizzo Itaobuy Spreadsheet da diversi mesi e devo dire che la qualità delle informazioni è eccellente. Le foto QC mi aiutano a valutare i prodotti prima di procedere, un vero game changer.',
    rating: 5,
  },
  {
    name: 'Alessandro F.',
    location: 'Napoli, Italia',
    text: 'La guida italiana su Itaobuy Spreadsheet mi ha aiutato tantissimo a capire come funziona questo strumento. Finalmente posso navigare tra le categorie in modo semplice e veloce.',
    rating: 4,
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            Testimonianze
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Cosa dicono gli utenti
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-background-200/70 p-6 md:p-7"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, starIdx) => (
                  <span key={starIdx} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-500 font-semibold text-sm">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10 gap-3">
          <Link
            to="/articoli/itaobuy-spreadsheet-guida-completa"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Leggi la guida completa
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold text-sm rounded-full hover:border-foreground-400 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            Visita kaspreadsheet.com
          </a>
        </div>
      </div>
    </section>
  );
}